(() => {
  const BUTTON_SELECTOR = '[data-ecomhard-compre-traje]';
  const TARGET_SELECTOR = '[data-ecomhard-traje]';

  function getTarget() {
    return document.querySelector(TARGET_SELECTOR);
  }

  function syncButtons() {
    const hasTarget = Boolean(getTarget());

    document.querySelectorAll(BUTTON_SELECTOR).forEach((button) => {
      button.hidden = !hasTarget;
    });
  }

  function scrollToOutfit(event) {
    const button = event.target.closest(BUTTON_SELECTOR);
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const target = getTarget();

    if (!target) {
      button.hidden = true;
      return;
    }

    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }

  function init() {
    syncButtons();

    document.addEventListener('click', scrollToOutfit);

    /* Theme Editor / section rendering */
    document.addEventListener('shopify:section:load', syncButtons);
    document.addEventListener('shopify:section:unload', syncButtons);
    document.addEventListener('shopify:section:reorder', syncButtons);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
